export class AwsRuntimeConfig {
    'iamRoleArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "iamRoleArn",
            "baseName": "iamRoleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRuntimeConfig.attributeTypeMap;
    }
    constructor() {
    }
}
